import React, { useState, useEffect } from "react";
import Sidebar from "./Components/Sidebar";
import Header from "./Components/Header";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { dashboardRoutes as menuRoutes } from "./config/dashboardRoutes";


export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [activeNav, setActiveNav] = useState("Dashboard");
  const [sidebarWidth, setSidebarWidth] = useState(240);


  // Collapse sidebar on table pages (optional)
  const isTablePage = location.pathname.includes("/data-table");
  useEffect(() => {
    setCollapsed(isTablePage);
  }, [isTablePage]);

  // Sync sidebar highlight with current URL
  useEffect(() => {
    const current = menuRoutes.find((route) =>
      location.pathname.startsWith(route.path)
    );
    if (current) setActiveNav(current.label);
  }, [location.pathname]);

  return (
    <div
      className="layout-wrapper"
      style={{ display: "flex", position: "relative" }}
    >
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        activeNav={activeNav}
        setActiveNav={setActiveNav}
        setSidebarWidth={setSidebarWidth}
      />

     <div
  className="main-content"
  style={{
    paddingLeft: collapsed ? "60px" : "240px",
    paddingTop: "60px",
    transition: "padding-left 0.3s ease",
  }}
>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        <Outlet />
      </div>
    </div>
  );
}
